import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { shareContent } from '../../utils/shareUtils';
import './CommunityEventPage.css';

const CommunityEventPage = () => {
  const navigate = useNavigate();
  const [shareMessage, setShareMessage] = useState('');

  // 채널톡 열기 함수
  const openChannelTalk = () => {
    // Google Analytics 이벤트 추적
    if (typeof window.gtag !== 'undefined') {
      window.gtag('event', 'community_apply_click', {
        event_category: 'Events',
        event_label: 'community_detail_page',
        value: 1
      });
    }

    // 채널톡이 로드되어 있는지 확인
    if (window.ChannelIO) {
      window.ChannelIO('show');
    } else {
      window.location.href = 'mailto:angel@plactical.com?subject=[교사 커뮤니티 포스팅 이벤트] 왓퀴즈 사용 후기 포스팅';
    }
  };

  const goBack = () => {
    navigate('/events');
  };

  // 이벤트 공유 함수
  const handleShareEvent = async () => {
    const shareData = {
      title: '왓퀴즈 교사 커뮤니티 포스팅 이벤트 - 신세계 상품권 1만원!',
      text: '교사 커뮤니티에 왓퀴즈 후기를 작성하고 신세계 상품권 1만원을 받아보세요! 교사용 AI 플랫폼',
      url: `${window.location.origin}/events/community`
    };

    if (typeof window.gtag !== 'undefined') {
      window.gtag('event', 'community_share_click', {
        event_category: 'Events',
        event_label: 'community_page_share',
        value: 1
      });
    }

    const result = await shareContent(shareData);
    
    if (result.success) {
      setShareMessage('이벤트가 공유되었습니다!');
    } else if (result.error) {
      setShareMessage(result.error.includes('복사') ? 'URL이 복사되었습니다!' : '공유에 실패했습니다.');
    }

    setTimeout(() => setShareMessage(''), 3000);
  };

  const benefits = [
    {
      title: '신세계 상품권 1만원',
      description: '포스팅 승인 시 즉시 지급'
    },
    {
      title: 'PRO 30일 이용권',
      description: '계정 확인 후 바로 적용'
    },
    {
      title: '다른 이벤트 중복 참여',
      description: '블로그, 인터뷰, 추천 등 모두 참여 가능'
    }
  ];

  const guideItems = [
    { label: '텍스트', value: '500자 이상' },
    { label: '사용 화면', value: '스크린샷 5장 이상' },
    { label: '링크', value: 'whatquiz.co.kr 삽입' },
    { label: '키워드', value: '왓퀴즈, 교사용GPT, AI생기부작성' },
    { label: '내용', value: '실제 활용 후기, 팁, 노하우' },
    { label: '커뮤니티', value: '인디스쿨, 아이스크림, 교사 카페 등' }
  ];

  return (
    <div className="community-event-page">
      <Helmet>
        <title>교사 커뮤니티 포스팅 이벤트 - 왓퀴즈</title>
        <meta name="description" content="교사 커뮤니티에 왓퀴즈 사용 후기를 포스팅하고 신세계 상품권 1만원을 받으세요!" />
        <meta property="og:title" content="교사 커뮤니티 포스팅 이벤트 - 왓퀴즈" />
        <meta property="og:description" content="교사 커뮤니티에 왓퀴즈 사용 후기를 포스팅하고 신세계 상품권 1만원을 받으세요!" />
      </Helmet>

      {/* 헤더 섹션 */}
      <section className="community-header">
        <div className="container">
          <button className="back-button" onClick={goBack}>
            ← 이벤트 목록
          </button>
          
          <div className="page-title-section">
            <div className="community-icon-wrap">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                <circle cx="9" cy="7" r="4"></circle>
                <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
              </svg>
            </div>
            <h1 className="community-title">커뮤니티 포스팅</h1>
            <p className="community-subtitle">교사 커뮤니티에 후기를 작성하고 리워드를 받으세요</p>
          </div>
        </div>
      </section>

      {/* 혜택 섹션 - Value First */}
      <section className="community-benefits">
        <div className="container">
          <h2>참여 혜택</h2>
          <div className="benefits-grid">
            {benefits.map((benefit, index) => (
              <div key={index} className="benefit-card">
                <span className="benefit-num">{index + 1}</span>
                <h3 className="benefit-title">{benefit.title}</h3>
                <p className="benefit-description">{benefit.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 작성 가이드 섹션 */}
      <section className="community-guide">
        <div className="container">
          <h2>작성 가이드</h2>
          <div className="guide-list">
            {guideItems.map((item, index) => (
              <div key={index} className="guide-item">
                <span className="guide-label">{item.label}</span>
                <span className="guide-value">{item.value}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA 섹션 */}
      <section className="community-apply">
        <div className="container">
          <div className="apply-content">
            <h2>지금 바로 참여하세요</h2>
            <p>
              포스팅 완료 후 채널톡으로 링크를 보내주시면<br/>
              검토 후 3일 내 상품권을 발송해드려요
            </p>
            
            <div className="apply-info">
              <div className="info-item">
                <strong>참여 방법</strong>
                <span>채널톡으로 포스팅 링크 제출</span>
              </div>
              <div className="info-item">
                <strong>심사 기준</strong>
                <span>글자 수, 이미지, 링크, 키워드</span>
              </div>
              <div className="info-item">
                <strong>리워드 발송</strong>
                <span>승인 후 3일 내 카카오톡 발송</span>
              </div>
            </div>

            <div className="button-group">
              <button className="apply-button" onClick={openChannelTalk}>
                포스팅 링크 제출하기
              </button>
              
              <button className="share-button" onClick={handleShareEvent}>
                이벤트 공유하기
              </button>
            </div>

            {shareMessage && (
              <div className="share-message">
                {shareMessage}
              </div>
            )}

            <p className="apply-note">
              * 승인 후 3일 내 개별 연락드립니다
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CommunityEventPage;
